export default "__VITE_ASSET__BklbkT9w__"